module.exports = __webpack_public_path__ + "img/lv6.41637f9a.png";